(function() { window.GUID_0687c006_1bce_4d0f_8e5e_3fec963fcb6a = { getGuid: function() { return "0687c006-1bce-4d0f-8e5e-3fec963fcb6a"; } }; })();
//function ShowConfirmDialog(htmlContent?, delegatebuttons?, okOnEnter?: boolean) {
//    var resultCallback= {
//        Ok: undefined,
//        Cancel: undefined,
//        Close: undefined,
//        dialog: undefined
//    };
//    if (delegatebuttons == null)
//    {
//        delegatebuttons = {};
//        delegatebuttons = {
//            "Ok": function () {
//                $(this).dialog("close");
//                if (typeof (resultCallback.Ok) != "undefined") {
//                    resultCallback.Ok.call(this);
//                }
//            },
//            Cancel: function () {
//                $(this).dialog("close");
//                if (typeof (resultCallback.Cancel) != "undefined") {
//                    resultCallback.Cancel.call(this);
//                }
//            }
//        };
//    }  
//    if (htmlContent == null || htmlContent == "") {
//        htmlContent = JSRess.AreYouSure;
//    }
//    if (htmlContent instanceof jQuery)
//    {
//        htmlContent = htmlContent[0].outerHTML;
//    }
//    var dialog = $('<div>' + htmlContent + '</div>');
//    dialog.dialog({
//        autoOpen: true,
//        //autoResize: true,
//        resizable: false,
//        width: 'auto',
//        modal: true,
//        title: "",
//        show: {
//            effect: "slide",
//            duration: 250
//        },
//        hide: {
//            effect: "slide",
//            duration: 250
//        },
//        buttons: delegatebuttons,
//        create: function (event, ui) {
//        },
//        open: function () {
//            $(this).parent().promise().done(function () {
//                var data = {
//                    formDialog: this
//                };
//                CS.trigger('popup.shown', data);
//            });
//        },
//        beforeClose: function (event, ui) {
//        },
//        close: function () {
//            if (typeof (resultCallback.Close) != "undefined") {
//                resultCallback.Close.call(this);
//            }
//            var data = {
//                formDialog: this
//            };
//            CS.trigger('popup.closed', data);
//            dialog.remove();
//        }
//    });
//    if (okOnEnter) {
//        dialog.on('keypress', function (e) {
//            if (e.keyCode == $.ui.keyCode.ENTER) {
//                //Close dialog and/or submit here...
//                dialog.dialog("close");
//                if (typeof (resultCallback.Ok) != "undefined") {
//                    resultCallback.Ok.call(this);
//                }
//            }
//        });
//    }
//    resultCallback.dialog = dialog;
//    return resultCallback;
//}

//# sourceMappingURL=cs.confirmdialog.js.map
